import LogsHeader from "./components/LogsHeader/LogsHeader"
import LogsTable from "./components/LogsTable/LogsTable"


const LogsPage = () => {

  return (
    <section className="section-wrapper">
      <LogsHeader />
      <LogsTable />
    </section>
  )
}

export default LogsPage
